import { OAuthUrl } from '../pages/oauthUrls/types';

/**
 * Gets the advertiser ID from an OAuth URL based on the platform
 * @param oauthUrl - The OAuth URL object
 * @returns The advertiser ID or '-' if not found
 */
export const getOAuthUrlAdvertiserId = (oauthUrl: OAuthUrl): string => {
  if (oauthUrl.amazonAdvertiserId)
    return oauthUrl.amazonAdvertiserId.toString();
  if (oauthUrl.redditAdAccountId) return oauthUrl.redditAdAccountId.toString();
  if (oauthUrl.tiktokAdvertiserId)
    return oauthUrl.tiktokAdvertiserId.toString();
  return '-';
};

/**
 * Sorts OAuth URLs based on the specified column and sort order
 * @param urls - Array of OAuth URLs to sort
 * @param sortBy - Column name to sort by
 * @param sortOrder - Sort order ('ASC' or 'DESC')
 * @returns Sorted array of OAuth URLs
 */
export const sortOAuthUrls = (
  urls: OAuthUrl[],
  sortBy: string,
  sortOrder: 'ASC' | 'DESC'
): OAuthUrl[] => {
  return [...urls].sort((a, b) => {
    let aValue: any;
    let bValue: any;

    switch (sortBy) {
      case 'clientName':
        aValue = a.clientName?.toLowerCase() || '';
        bValue = b.clientName?.toLowerCase() || '';
        break;
      case 'description':
        aValue = a.description?.toLowerCase() || '';
        bValue = b.description?.toLowerCase() || '';
        break;
      case 'platform':
        aValue = a.platform?.toLowerCase() || '';
        bValue = b.platform?.toLowerCase() || '';
        break;
      case 'advertiserId': {
        aValue = getOAuthUrlAdvertiserId(a).toLowerCase();
        bValue = getOAuthUrlAdvertiserId(b).toLowerCase();
        break;
      }
      case 'createdBy':
        aValue = a.createdBy?.toLowerCase() || '';
        bValue = b.createdBy?.toLowerCase() || '';
        break;
      case 'createdAt':
        aValue = new Date(a.createdAt).getTime();
        bValue = new Date(b.createdAt).getTime();
        break;
      case 'credentialsGeneratedAt':
        aValue = a.credentialsGeneratedAt
          ? new Date(a.credentialsGeneratedAt).getTime()
          : 0;
        bValue = b.credentialsGeneratedAt
          ? new Date(b.credentialsGeneratedAt).getTime()
          : 0;
        break;
      default:
        aValue = a.createdAt ? new Date(a.createdAt).getTime() : 0;
        bValue = b.createdAt ? new Date(b.createdAt).getTime() : 0;
    }

    if (aValue < bValue) return sortOrder === 'ASC' ? -1 : 1;
    if (aValue > bValue) return sortOrder === 'ASC' ? 1 : -1;
    return 0;
  });
};
